import {Component, Input} from "@angular/core";

/**
 * A component that renders an SVG icon for "Tune Vertical Variant"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-tune-vertical-variant',
    templateUrl: './icon-tune-vertical-variant.component.html',
    styleUrls: ['./icon-tune-vertical-variant.component.scss'],
    standalone: false
})
export class IconTuneVerticalVariantComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
